export default function OrderSubPage({ children }) {
	return <div className="flex flex-column h-100 w-100 flex-shrink-0">{children}</div>
}
